// Known Third Party Setups and their settings (server: HotelBeds::SETTING_NAMES,
// Azamara::SETTING_NAMES). Picking one in the setup editor fills in the name and every
// setting with its default; the type decides the input:
//   boolean  - switch, stored as "true"/"false"
//   password - masked text
//   number   - numeric text
//   text     - plain text (default)
// Settings that are not listed here are still shown and edited as plain text.
export const THIRD_PARTY_SETUP_TEMPLATES = [
  {
    // #11460
    name: "HotelBeds API",
    label: "HotelBeds",
    level: "OWNER",
    settings: [
      { name: "api_key", hint: "From the HotelBeds developer portal" },
      { name: "secret", type: "password" },
      {
        name: "booking_endpoint",
        default: "https://api.test.hotelbeds.com/hotel-api/1.0",
        hint: "Live: https://api.hotelbeds.com/hotel-api/1.0",
      },
      {
        name: "content_endpoint",
        default: "https://api.test.hotelbeds.com/hotel-content-api/1.0",
        hint: "Live: https://api.hotelbeds.com/hotel-content-api/1.0",
      },
      {
        name: "sync_countries",
        hint: "Country codes for the hotel download, comma separated, e.g. ES,PT,FR",
      },
      {
        name: "auto_create",
        type: "boolean",
        default: "false",
        hint:
          "Off: only hotels approved for HotelBeds are searched. On: every HotelBeds hotel in the destination is searched and missing suppliers are created.",
      },
    ],
  },
  {
    // #11473
    name: "Azamara API",
    label: "Azamara Cruises (SeaWare OTA)",
    level: "OWNER",
    settings: [
      { name: "endpoint", default: "https://uat.sw.api.azamara.online/ota/rest" },
      { name: "region", default: "us-east-1" },
      { name: "username", hint: "AWS access key id" },
      { name: "password", type: "password", hint: "AWS secret access key" },
      { name: "requestor_id", type: "password" },
      { name: "residency", default: "US" },
      { name: "currency", default: "USD" },
      { name: "max_sailings", type: "number", default: "50" },
      {
        name: "rate_type",
        hint: "Per person, per stay rate type code; empty uses PPPS or the first one found",
      },
      {
        name: "auto_create",
        type: "boolean",
        default: "true",
        hint:
          "On: ships and cabin categories missing in GTWeb are created. Off: only linked or same-name ones are used.",
      },
      { name: "proxy_host" },
      { name: "proxy_port", type: "number" },
      { name: "proxy_username" },
      { name: "proxy_password", type: "password" },
    ],
  },
];

export function thirdPartySetupTemplate(setupName) {
  return (
    THIRD_PARTY_SETUP_TEMPLATES.find(
      (t) => t.name == (setupName || "").trim()
    ) || null
  );
}

export function thirdPartySettingDefinition(setupName, settingName) {
  const template = thirdPartySetupTemplate(setupName);
  const found =
    template &&
    template.settings.find((s) => s.name == (settingName || "").trim());
  return { type: "text", hint: "", ...(found || {}) };
}

export function isTrueSetting(content) {
  return ["true", "yes", "1", "on"].includes(
    (content || "").toString().trim().toLowerCase()
  );
}



// WEBPACK FOOTER //
// ./src/constants/thirdPartySetups.js